<template>
    <div class="card">
        <div class="card-header">
            <div class="card-title">
                <span class="font-weight-bold" v-if="active === 1">Phiếu đăng ký học tập</span>
                <span class="font-weight-bold" v-if="active === 2">Hoàn tất phiếu đăng ký học tập</span>
                <span class="font-weight-bold" v-if="active === 3">Gửi phiếu đăng ký học tập</span>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <el-steps :active="active" align-center>
                        <el-step title="Tạo phiếu đăng ký học tập"></el-step>
                        <el-step title="Hoàn tất phiếu đăng ký học tập"></el-step>
                        <el-step title="Gửi phiếu đăng ký học tập"></el-step>
                    </el-steps>
                </div>
            </div>
            <div class="mt-6">
                <RegisterStudyForm
                    v-if="active === 1 && contractReady"
                    ref="formRef"
                    :errorsForm="errorsForm"
                    :contract_prop="contract"
                    @dataContract="dataContract"
                />

                <div
                    v-else-if="active === 1"
                    v-loading="true"
                    style="min-height: 300px"
                />
                <CompletedStudyForm
                    :contract="contract"
                    :policy="policy"
                    v-if="active === 2"></CompletedStudyForm>
                <CustomerConfirmForm
                    :contract="contract"
                    v-if="active === 3"
                    :url_copy="url_copy"
                    :url_confirm_contract="url_confirm_contract"
                ></CustomerConfirmForm>
            </div>
        </div>
        <div class="card-header d-flex justify-content-end">
            <button class="btn btn-default mr-2" v-if="active > 1" @click="back">Quay lại</button>
            <button class="btn btn-success" v-if="active === 1" :disabled="is_loading_submit" @click="createStudy"><i
                v-if="is_loading_submit"
                class="el-icon-loading"></i>
                <span v-if="!contract.id">Tạo phiếu</span>
                <span v-else>Cập nhật</span>
            </button>
            <button class="btn btn-success" v-if="active === 2" :disabled="is_loading_submit" @click="completedStudy"><i
                v-if="is_loading_submit"
                class="el-icon-loading"></i>Hoàn tất
            </button>
            <button class="btn btn-success" v-if="active === 3" :disabled="is_loading_submit" @click="confirm"><i
                v-if="is_loading_submit"
                class="el-icon-loading"></i>Xác
                nhận
            </button>
        </div>
        <entrance-list-dialog
            :visible.sync="entranceListDialogVisible"
            :list="listExam"
            @view="handleViewEntranceExam"
        />
        <entrance-block-consult-dialog
            :visible.sync="entranceBlockDialogVisible"
            :loading="loadingListExam"
            message="Chưa thể tạo hợp đồng do khách hàng đang trong quá trình kiểm tra năng lực đầu vào"
            @view="viewEntranceExams"
        />
    </div>
</template>
<script>
import {mapGetters} from "vuex";

import Multiselect from "vue-multiselect";
import lodash from 'lodash-es';
import deepdash from 'deepdash-es';
import RegisterStudyForm from "@/views/pages/customer/components/RegisterStudyForm";
import CompletedStudyForm from "@/views/pages/customer/components/CompletedStudyForm";
import CustomerConfirmForm from "@/views/pages/customer/components/CustomerConfirmForm";
import EntranceBlockConsultDialog from "@/views/pages/customer/components/EntranceBlockConsultDialog.vue";
import EntranceListDialog from "@/views/pages/customer/components/EntranceListDialog.vue";
import {GET_LIST_EXAM} from "@/core/services/store/customer/entrance.module";
import {GET_SPEAKING_BY_TEST_INPUT} from "@/core/services/store/customer/testInput.module";
import {STATUS_ONLY_GENERAL, TYPE_SPEAKING_AI} from "@/core/config/testInput/testInputOption";
import {
    CONTRACT_ONLINE_CREATE,
    CONTRACT_ONLINE_GET_BY_ID, CONTRACT_ONLINE_GET_SHORT_LINK, CONTRACT_ONLINE_UPDATE, GET_POLICY,
    CONTRACT_FIND_BY_CUSTOMER
} from "@/core/services/store/contract/contractOnline.module";
import {CUSTOMER_UPDATE_LEVEL} from "@/core/services/store/customer/customer.module";
import {LEVEL_3A} from "@/core/config/customer/customerOption";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {CAMBRIDGE, ECOACH, IELTS, TOEIC, ANU, IELTS_CAMBRIDGE, MENTER_ENGLISH_MASTERY} from "../../../core/config/center/centerOption";
import {GET_PROVINCES} from "../../../core/services/store/public/provinces.module";
import {GET_DISTRICTS} from "../../../core/services/store/public/districts.module";
import {GIFT_LIMIT_MESSAGE, isGiftLimitExceeded} from "@/core/services/contractService";

const _ = deepdash(lodash);
const MESSAGE_EXAM_IN_PROGRESS = 'Khách hàng đang thi dở nên chưa thể tạo hợp đồng';
export default {
    name: "RegisterStudy",
    props: {},
    components: {
        EntranceBlockConsultDialog,
        EntranceListDialog,
        CustomerConfirmForm,
        CompletedStudyForm,
        RegisterStudyForm,
        Multiselect
    },
    data() {
        return {
            errorsForm: {},
            active: 1,
            is_loading_submit: false,
            entranceBlockDialogVisible: false,
            entranceListDialogVisible: false,
            listExam: [],
            loadingListExam: false,
            contractReady: false,
            contract: {
                policy: null,
                id: '',
                uuid: '',
                uuid_secret: '',
                is_confirm: 0,
                tuition_payment_id: '',
                is_older: true,
                name: '',
                phone: '',
                phone_other: '',
                email: '',
                birthday: '',
                center_id: '',
                branch_id: '',
                customer_id: this.$route.query.customer_id,
                total: '',
                total_need: 0,
                total_after_voucher: 0,
                total_paid: 0,
                destroy_fee: 0,
                total_promotions: 0,
                service_id: null,
                service: null,
                service_total: 0,
                method_payment_id: '',
                courses: [
                    {
                        id: "",
                        name: "",
                        fee: 0
                    }
                ],
                student_register_courses : [
                    {
                        course: {},
                        fee: '',
                    }
                ],
                list_promotions: [],
                gift_id: [],
                parent: {
                    type: 'bo',
                    other_value: '',
                    name: '',
                    phone: '',
                    phone_other: '',
                },
                policy_id: '',
                policy_ver: '',
                province_id: '',
                district_id: '',
                overlap_time: '',
                contact_time_frame: '',
                contract_change: '',
                other_content: ''
            },
            url_copy: '',
            url_confirm_contract: '',
            policy: {},
        }
    },
    watch: {
        contract() {

        }
    },
    async mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Danh sách hợp đồng tư vấn" },
            {
                title: "Phiếu đăng ký học tập",
                icon: "far fa-user",
            },
        ]);

        try {
            await this.getContractByCustomer();

            if (this.contract.id) {
                await this.getById();
            }
        } catch (error) {
            console.error("Load contract error:", error);
            // this.$message.error("Không thể tải thông tin phiếu đăng ký");
        } finally {
            this.contractReady = true;
        }
    },
    methods: {
        getContractByCustomer() {
            let customer_id = this.$route.query.customer_id;
            return this.$store.dispatch(CONTRACT_FIND_BY_CUSTOMER, customer_id).then((data) => {
                this.contract.id = data.data;
            });
        },
        dataContract(data) {
            this.contract = data;
        },
        //mỗi hợp đồng chỉ được 1 bộ quà tặng, chặn không cho gửi request nếu đang chọn nhiều hơn
        validateGiftLimit() {
            if (!isGiftLimitExceeded(this.contract)) {
                return true;
            }
            this.$message.error(GIFT_LIMIT_MESSAGE);
            return false;
        },
        async createStudy() {
            if (!this.validateGiftLimit()) {
                return;
            }
            const hasPromotion = this.contract.list_promotions.length > 0 || this.contract.gift_id.length > 0;
            if (!hasPromotion) {
                this.$message.error('Vui lòng chọn khuyến mãi');
                return;
            }
            const { valid } = await this.$refs.formRef.validateForm();
            if (!valid) return;
            if (this.contract.id) {
                this.editForm();
            } else {
                this.createForm();
            }
        },
        editForm() {
            this.is_loading_submit = true;
            this.$store.dispatch(CONTRACT_ONLINE_UPDATE, this.contract).then((data) => {
                this.$message.success(data.message);
                this.contract.id = data.data.id;
                this.contract.uuid = data.data.uuid;
                this.contract.uuid_secret = data.data.uuid_secret;
                this.contract.gift_id = data.data.gift_id;
                this.contract.address = data.data.address;
                this.contract.description = data.data.gifts.length ? data.data.gifts[0].description : '';
                this.next();
                this.changeLink();
                this.getContractById(this.contract.id);
            }).catch((e) => {
                this.handleFormValidationError(e);
            }).finally(() => {
                this.is_loading_submit = false;
            })
        },
        createForm() {
            this.is_loading_submit = true;
            this.$store.dispatch(CONTRACT_ONLINE_CREATE, this.contract).then((data) => {
                this.$message.success(data.message);
                this.contract.id = data.data.id;
                this.contract.uuid = data.data.uuid;
                this.contract.uuid_secret = data.data.uuid_secret;
                this.contract.policy_ver = data.data.policy_ver;
                this.contract.gift_id = data.data.gift_id;
                this.contract.address = data.data.address;
                this.contract.description = data.data.gifts.length ? data.data.gifts[0].description : '';
                // this.confirmCustomer();
                this.next();
                this.changeLink();
                this.getPolicy();
            }).catch((e) => {
                this.handleFormValidationError(e);
            }).finally(() => {
                this.is_loading_submit = false;
            })
        },
        handleFormValidationError(e, fallbackMessage = 'Cập nhật thất bại') {
            if (e?.data?.message === MESSAGE_EXAM_IN_PROGRESS) {
                this.entranceBlockDialogVisible = true;
                return;
            }
            const validationErrors = e?.data?.data?.message_validate_form;

            if (validationErrors) {
                this.errorsForm = validationErrors;
            }

            const firstValidationError = Object.values(validationErrors || {})?.[0]?.[0];

            this.$message.error({
                message: firstValidationError || e?.data?.message || fallbackMessage,
                duration: 10000,
                showClose: true,
            });
        },
        viewEntranceExams() {
            if (this.loadingListExam) return;
            this.loadingListExam = true;
            this.$store.dispatch(GET_LIST_EXAM, { customer_id: this.$route.query.customer_id }).then((res) => {
                const listExam = res?.data || [];
                if (!listExam.length) return;

                if (listExam.length > 1) {
                    this.listExam = listExam;
                    this.entranceListDialogVisible = true;
                    return;
                }

                return this.openEntranceExamDetail(listExam[0], '1');
            }).catch((error) => {
                this.$message.error(error?.data?.message ?? 'Lấy danh sách ca test thất bại');
            }).finally(() => {
                this.loadingListExam = false;
                this.entranceBlockDialogVisible = false;
            });
        },
        handleViewEntranceExam(exam) {
            this.entranceListDialogVisible = false;
            const isLatest = String(this.listExam[0]?.id) === String(exam.id) ? '1' : '0';
            this.openEntranceExamDetail(exam, isLatest);
        },
        openEntranceExamDetail(exam, isLatest = '1') {
            const customerId = this.$route.query.customer_id;
            if (exam.exam_type === 'Thi đầu khóa') {
                this.$router.push({
                    name: 'customer-entrance-exam-schedule',
                    params: { marking_exam_retake_id: exam.id },
                    query: { is_latest: isLatest, customer_id: customerId }
                });
                return;
            }
            if (exam.exam_type === 'Test đầu vào' || exam.exam_type === 'Test sơ bộ') {
                const goToDetail = (status) => {
                    const query = { is_latest: isLatest, customer_id: customerId };
                    if (status != null) query.status = status;
                    this.$router.push({
                        name: 'customer-test-input-entrance',
                        params: { id: exam.id },
                        query
                    });
                };
                if (+exam.status === STATUS_ONLY_GENERAL) {
                    goToDetail();
                    return;
                }
                return this.$store.dispatch(GET_SPEAKING_BY_TEST_INPUT, { id: exam.id }).then((data) => {
                    goToDetail(data?.data?.sub_type ? TYPE_SPEAKING_AI : undefined);
                }).catch(() => {
                    goToDetail();
                });
            }
        },
        changeLink() {
            let path_url_copy = `/xac-thuc?code=${this.contract.uuid}`;
            let path_url_confirm_contract = `/xac-thuc?code=${this.contract.uuid}&check=${this.contract.uuid_secret}`;
            let domain = '';
            switch (this.contract.center_id) {
                case ECOACH:
                    domain = `${process.env.VUE_APP_BASE_URL_ECOACH}`;
                    break;
                case IELTS:
                case CAMBRIDGE:
                case MENTER_ENGLISH_MASTERY:
                    domain = `${process.env.VUE_APP_BASE_URL_IELTS}`;
                    break;
                case TOEIC:
                    domain = `${process.env.VUE_APP_BASE_URL_TOEIC_MASTER}`;
                    break;
                case IELTS_CAMBRIDGE:
                    domain = `${process.env.VUE_APP_BASE_URL_IELTS}`;
                    break;
                case ANU:
                    domain = `${process.env.VUE_APP_BASE_URL_ANU}`;
                    break;
            }
            this.url_copy = this.getShortLinkUrlCopy(domain + path_url_copy);
            this.url_confirm_contract = this.getShortLinkConfirm(domain + path_url_confirm_contract);
        },
        getShortLinkUrlCopy(url) {
            this.$store.dispatch(CONTRACT_ONLINE_GET_SHORT_LINK, {
                url: url,
                center_id: this.contract.center_id
            }).then((data) => {
                this.url_copy = data.data;
            });
        },
        getShortLinkConfirm(url) {
            this.$store.dispatch(CONTRACT_ONLINE_GET_SHORT_LINK, {
                url: url,
                center_id: this.contract.center_id
            }).then((data) => {
                this.url_confirm_contract = data.data;
            });
        },
        async getById() {
            const response = await this.$store.dispatch(
                CONTRACT_ONLINE_GET_BY_ID,
                this.contract.id
            );

            this.contract = response.data;

            const paymentOptions = this.contract.payment_options;

            if (paymentOptions?.payment_expired) {
                const now = new Date();
                const paymentExpired = new Date(paymentOptions.payment_expired);

                if (paymentExpired < now) {
                    this.$notify({
                        title: "Cảnh báo!",
                        message: "Phương thức thanh toán của hợp đồng đã hết hạn",
                        type: "warning",
                    });
                }
            }

            return this.contract;
        },
        completedStudy() {
            this.next();
        },
        confirmCustomer() {
            this.$store.dispatch(CUSTOMER_UPDATE_LEVEL, {
                customer_id: this.contract.customer_id,
                level: LEVEL_3A
            }).then(() => {
                this.$message.success('Xác nhận thành công');
            }).catch((e) => {
                this.$message.error(e.data.message);
            })
        },
        confirm() {
            this.$router.push({
                name: "contract-index"
            })
        },
        next() {
            if (this.active++ > 2) this.active = 1;
        },
        back() {
            if (this.active-- === 0) this.active = 1;
            if (this.contract.id) {
                this.getContractById(this.contract.id);
            }
        },
        getContractById(id) {
            this.$store.dispatch(CONTRACT_ONLINE_GET_BY_ID, id).then((data) => {
                this.contract = data.data;
            })
        },
        getPolicy() {
            this.$store.dispatch(GET_POLICY, {
                policy_id: this.contract.center_id,
                policy_ver: this.contract.policy_ver,
                tuition_payment_id: this.contract.tuition_payment_id
            }).then((data) => {
                _.sortBy(data.data, 'index')
                this.policy = data.data;
            })
        }
    },
    computed: {
        ...mapGetters(['currentUser'])
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.withdraw-course {
    position: absolute;
    right: 20px;
    top: 37px;
}
</style>
